import { mountIssuesListApp } from '~/issues/list';

mountIssuesListApp();
